// Scroll timeline of the landing's carbon-map story, as fractions of the sticky section's scroll.
// After the hero, the stage turns into the real Bản đồ carbon UI (top bar, parcel panel, layer
// dock — the same components as /app/carbon-map) and plays the app's own flow on one parcel:
// sync → pick → satellite scan → results → 3D model. The 3D scene and the UI both read this,
// so they change on the same frame. Windows are [in-start, in-end, out-start, out-end].
import type { Stage, Year } from '../../carbonmap/types'

export type Win = readonly [number, number, number, number]

export const STORY = {
  heroOut: [0.04, 0.09] as const, // hero copy leaves
  app: [0.06, 0.11, 0.91, 0.95] as Win, // the real app chrome slides in / out
  sync: [0.08, 0.16] as const, // "Đồng bộ địa chính": sync log + a wave across the parcels
  pick: 0.16, // stage 'pick'
  tap: 0.205, // tap ripple on the parcel
  select: 0.22, // stage 'scan': parcel panel, outline traces itself
  trace: [0.22, 0.25] as const,
  scan: [0.25, 0.35] as const, // NDVI 10 m cells paint row by row under the scan line
  result: 0.36, // stage 'result': the analysis lands in the panel
  cir: [0.38, 0.4, 0.52, 0.54] as Win, // layer dock → false colour, then the years
  y2017: 0.41,
  y2020: 0.45,
  y2026: 0.49,
  tabs: 0.55, // panel reaches the carbon / yield tabs
  yieldTab: 0.62,
  press3d: 0.675, // "Dựng mô hình 3D của thửa" pressed
  model3d: 0.7, // stage 'model3d'
  build: [0.7, 0.715, 0.75, 0.77] as Win, // AI glow + "đang dựng" pill while the twin builds
  grow: [0.76, 0.87] as const, // tall trees rise at their crown tops
  outro: [0.93, 0.96] as const,
  focus: [0.17, 0.24, 0.9, 0.96] as Win, // spotlight that dims everything but the parcel
}

const clamp01 = (v: number) => Math.max(0, Math.min(1, v))
export const smooth = (a: number, b: number, v: number) => {
  const t = clamp01((v - a) / (b - a))
  return t * t * (3 - 2 * t)
}
export const lin = (a: number, b: number, v: number) => clamp01((v - a) / (b - a))
export const inWin = (w: Win, v: number) => smooth(w[0], w[1], v) * (1 - smooth(w[2], w[3], v))

/** the app's stage (top-bar stepper) at progress p */
export const stageAt = (p: number): Stage =>
  p < STORY.pick ? 'sync' : p < STORY.select ? 'pick' : p < STORY.result ? 'scan' : p < STORY.model3d ? 'result' : 'model3d'

/** the year selected in the layer dock at progress p */
export const yearAt = (p: number): Year => (p >= STORY.y2017 && p < STORY.y2020 ? 2017 : p >= STORY.y2020 && p < STORY.y2026 ? 2020 : 2026)
